import axios from 'axios';

export default {
  
  getBaseUrl() {
    if(!this.baseUrl){
      this.baseUrl = process.env.WEB_CONSOLE_API_URL;
    }
    return this.baseUrl;
  },

  getAxios() {
    if(!this.axios){
      this.axios = axios.create({
        baseURL: this.getBaseUrl(),
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }
    return this.axios;
  },

  getAuthorizationHeader(token) {
    if (token) {
      return { 'Authorization': `Bearer ${token}` };
    }
    return {};
  },

  getToken() {
    try {
      // First try to get token from sessionStorage
      const storedToken = sessionStorage.getItem('api_token');
      
      // If not in sessionStorage, get from URL parameters
      const urlToken = new URLSearchParams(window.location.search).get('token');

      if (storedToken && (storedToken == urlToken || !urlToken)) {
        return storedToken;
      }
      
      // If token exists in URL, store it in sessionStorage for future use
      if (urlToken) {
        try {
          sessionStorage.setItem('api_token', urlToken);
        } catch (e) {
          console.warn('Could not save token to sessionStorage:', e);
        }
        return urlToken;
      }

      // Check localStorage for "remember me" token
      const rememberedToken = localStorage.getItem('api_token');
      const tokenExpiry = localStorage.getItem('api_token_expiry');
      if (rememberedToken && tokenExpiry) {
        if (Date.now() < Number(tokenExpiry)) {
          return rememberedToken;
        }
        localStorage.removeItem('api_token');
        localStorage.removeItem('api_token_expiry');
      }
      
      return null;
    } catch (e) {
      console.error('Error retrieving token:', e);
      return null;
    }
  },

  axiosGet(urlPath, overrideHeader) {
    const token = this.getToken();
    
    const separator = urlPath.includes('?') ? '&' : '?';
    const path = `${urlPath}${separator}api_request=1`;
    
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const requestConfig = {
      headers: overrideHeader ? { ...headers, ...overrideHeader } : headers
    };
    
    return this.getAxios().get(path, requestConfig);
  },

  axiosDelete(urlPath, data, overrideHeader) {
    const token = this.getToken();
    
    const separator = urlPath.includes('?') ? '&' : '?';
    const path = `${urlPath}${separator}api_request=1`;
    
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const requestConfig = {
      headers: overrideHeader ? { ...headers, ...overrideHeader } : headers
    };

    if (data) {
      requestConfig.data = data;
    }
    
    return this.getAxios().delete(path, requestConfig);
  },

  axiosPost(urlPath, data, overrideHeader) {
    const token = this.getToken();

    const separator = urlPath.includes('?') ? '&' : '?';
    const path = `${urlPath}${separator}api_request=1`;
    
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const requestConfig = {
      headers: overrideHeader ? { ...headers, ...overrideHeader } : headers
    };
    
    return this.getAxios().post(path, data, requestConfig);
  },

  axiosPatch(urlPath, data, overrideHeader) {
    const token = this.getToken();

    const separator = urlPath.includes('?') ? '&' : '?';
    const path = `${urlPath}${separator}api_request=1`;
    
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const requestConfig = {
      headers: overrideHeader ? { ...headers, ...overrideHeader } : headers
    };
    
    return this.getAxios().patch(path, data, requestConfig);
  },

  axiosPut(urlPath, data, overrideHeader) {
    const token = this.getToken();

    const separator = urlPath.includes('?') ? '&' : '?';
    const path = `${urlPath}${separator}api_request=1`;
    
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const requestConfig = {
      headers: overrideHeader ? { ...headers, ...overrideHeader } : headers
    };
    
    return this.getAxios().put(path, data, requestConfig);
  },

  buildQueryString(filter) {
    if (!filter) {
      return '';
    }

    const params = new URLSearchParams();
    
    Object.keys(filter).forEach(key => {
      const value = filter[key];
      if (Array.isArray(value)) {
        value.forEach(item => params.append(`${key}[]`, item));
      } else {
        params.append(key, value);
      }
    });
    
    return params.toString();
  }
}

